<template>
  <b-form-group
    label="Projeler"
    label-for="id"
  >
    <validation-provider
      #default="{ errors }"
      name="Proje Videoları"
    >
      <v-select
        id="id"
        v-model="dataItem.id_projects"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Projeler"
      >
        <template v-slot:option="option">
          <div>
            {{ option.title }}
          </div>

        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
    <!--    <pre>-->
    <!--      {{ dataItem }}-->
    <!--    </pre>-->
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
  BCard,
  BCardHeader,
  BCardBody,
  BListGroup,
  BListGroupItem,
  BButton,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ProjectsVideoGallery',
  components: {
    BFormGroup,
    vSelect,
    BCard,
    BCardHeader,
    BCardBody,
    BListGroup,
    BListGroupItem,
    BButton,
    ValidationProvider,
  },
  data() {
    return {
      required,
      project_services: [],
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['projects/dataList']
    },
    dataItem() {
      return this.$store.getters['projects_video_gallery/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('projects/getDataList', {
        select: [
          'projects.id AS id',
          'projects.title AS title',
        ],
      })
    },
  },

}
</script>
